var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "spinner-container",
      style: { width: _vm.size + "px", height: _vm.size + "px" }
    },
    [
      _c("div", {
        staticClass: "spinner-inner",
        style: {
          width: _vm.size + "px",
          height: _vm.size + "px",
          borderWidth: _vm.borderSize + "px",
          borderColor: _vm.borderColor,
          borderTopColor: _vm.borderTopColor
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2db4f778", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2db4f778","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/commons/Spinner.vue
// module id = 1696
// module chunks = 1